/*
 * Copyright (c) 2008-present Sonatype, Inc.
 *
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/pro/attributions
 * Sonatype and Sonatype Nexus are trademarks of Sonatype, Inc. Apache Maven is a trademark of the Apache Foundation.
 * M2Eclipse is a trademark of the Eclipse Foundation. All other trademarks are the property of their respective owners.
 */
import React from 'react';
import {faKey} from '@fortawesome/free-solid-svg-icons';

import {Code, FieldWrapper} from '@sonatype/nexus-ui-plugin';
import {NxButton, NxFontAwesomeIcon, NxModal} from '@sonatype/react-shared-components';

import UIStrings from '../../../../constants/UIStrings';
import './UserToken.scss';

export default function UserTokenDetails({userToken, onCloseClick}) {
  return <NxModal className="nx-modal--wide" onClose={onCloseClick}>
    <header className="nx-modal-header">
      <h2 className="nx-h2">
        <NxFontAwesomeIcon icon={faKey}/>
        <span>{UIStrings.USER_TOKEN.MENU.text}</span>
      </h2>
    </header>
    <div className="nx-modal-content">
      <p>{UIStrings.USER_TOKEN.LABELS.USER_TOKEN_NOTE} <strong>{UIStrings.USER_TOKEN.LABELS.KEEP_SECRET_NOTE}</strong>
      </p>
      <FieldWrapper labelText={UIStrings.USER_TOKEN.LABELS.USER_TOKEN_NAME_CODE}>
        <Code name='nameCode' readOnly value={userToken.nameCode}/>
      </FieldWrapper>
      <FieldWrapper labelText={UIStrings.USER_TOKEN.LABELS.USER_TOKEN_PASS_CODE}>
        <Code name='passCode' readOnly value={userToken.passCode}/>
      </FieldWrapper>
      <FieldWrapper labelText={UIStrings.USER_TOKEN.LABELS.MAVEN_USAGE}>
        <Code
            name="mavenUsage"
            readOnly
            value={`<server>\n\t<id>\${server}</id>\n\t<username>${userToken.nameCode}</username>\n\t<password>${userToken.passCode}</password>\n</server>`}/>
      </FieldWrapper>
      <FieldWrapper labelText={UIStrings.USER_TOKEN.LABELS.BASE64_USER_TOKEN}>
        <Code
            name="base64"
            readOnly
            value={window.btoa(`${userToken.nameCode}:${userToken.passCode}`)}/>
      </FieldWrapper>
      <p>{UIStrings.USER_TOKEN.LABELS.AUTO_HIDE}</p>
    </div>
    <footer className="nx-footer">
      <div className="nx-btn-bar">
        <NxButton onClick={onCloseClick}>{UIStrings.USER_TOKEN.BUTTONS.CLOSE}</NxButton>
      </div>
    </footer>
  </NxModal>
}
